import React from 'react';

import { Footer, Meta, LocaleSelector } from '$partials/global';
import IconLogo from '$partials/icons/icon-logo.jsx';
import ModuleDispatcher from '$partials/modules/dispatcher.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').HygienePage}
 */
const HygienePage = (props) => {
    const page = props.data.page;

    return (
        <>
            <Meta
                domain={props.domain}
                page={page}
                title='Ion Riva' />

            <main
                className='type-style-body'
                id='main-content'>
                {/* Header */}
                <header className='layout-container px-layout-outer pb-60 sm:pt-60'>
                    <h1 className='sr-only'>
                        {page.title}
                    </h1>

                    <div className='relative mb-30'>
                        <div className='flex sm:block border-black pt-18'>
                            <div className='w-full flex gap-8 sm:gap-0 flex-col sm:flex-row'>
                                <div className='sm:w-6/12 md:w-4/12 sm:pr-30'>
                                    <a
                                        aria-label='Home'
                                        href='/'>
                                        <IconLogo className='w-[164px] h-[80px] sm:w-[329px] sm:h-[161px] text-black' />
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className='absolute right-0 bottom-0'>
                            <LocaleSelector />
                        </div>
                    </div>
                </header>

                {/* Modules */}
                {(page?.modules?.length > 0) &&
                    <div>
                        {page.modules.map((module, i) => (
                            <section
                                className='group/modulecontainer'
                                key={`${i}-${module?.id}`}>
                                <ModuleDispatcher
                                    {...module} />
                            </section>
                        ))}
                    </div>
                }
            </main>

            <Footer {...props.data.footer} />
        </>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default HygienePage;
